import React from 'react';
import T from 'prop-types';
import ReactPaginate from 'react-paginate';
import cx from 'classnames';

// TODO: move this file to Pagination folder
const Pagination = ({
  total,
  perPage,
  currentPage,
  className,
  pageRangeDisplayed = 5,
  marginPagesDisplayed = 2,
  previousLabel = 'hicon-arrow-left-new',
  nextLabel = 'hicon-arrow-right-new',
  onPageChange,
}) => {
  const pageCount = Math.ceil(total / perPage);

  return (
    <div className={cx('page-pagination', className)}>
      <ReactPaginate
        pageCount={pageCount}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
        previousLabel={<i className={previousLabel} />}
        nextLabel={<i className={nextLabel} />}
        breakLabel="..."
        breakClassName="break-me"
        forcePage={currentPage}
        containerClassName="pagination-list"
        activeClassName="active"
        onPageChange={onPageChange}
      />
    </div>
  );
};

Pagination.propTypes = {
  total: T.number.isRequired,
  perPage: T.number.isRequired,
  currentPage: T.number.isRequired,
  marginPagesDisplayed: T.number,
  pageRangeDisplayed: T.number,
  previousLabel: T.string,
  nextLabel: T.string,
  className: T.string,
  onPageChange: T.func.isRequired,
};

export default Pagination;
